import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { ViewerComponent } from './components/viewer/viewer.component';
import { ModalImageComponent } from './components/modal-image/modal-image.component';
import { AssistantChatComponent } from './components/assistant-chat/assistant-chat.component';
import { OdsDisplayComponent } from './components/ods-display/ods-display.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { SafeHtmlPipe } from './pipes/safehtml.pipe';
import { CategoriaFilterPipe } from './pipes/categoria-filter.pipe';
import { CategoriaImgFilterPipe } from './pipes/categoria-img-filter.pipe';

@NgModule({
  declarations: [
    ViewerComponent,
    ModalImageComponent,
    AssistantChatComponent,
    OdsDisplayComponent,
    DocumentViewerComponent,
    SafeHtmlPipe,
    CategoriaFilterPipe,
    CategoriaImgFilterPipe,
  ],
  imports: [CommonModule, RouterModule, MatTooltipModule, NgxDocViewerModule],
  exports: [
    ViewerComponent,
    ModalImageComponent,
    AssistantChatComponent,
    OdsDisplayComponent,
    DocumentViewerComponent,
    SafeHtmlPipe,
    CategoriaFilterPipe,
    CategoriaImgFilterPipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
